import React from 'react';
import { StaffEmployeeClockIn } from '@/components/staff/StaffEmployeeClockIn';

export const StaffClockInPage = () => {
  return <StaffEmployeeClockIn />;
};